import { CommonModule } from '@angular/common';
import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { InjectorClass } from '../../util';
import { LaunchedHookTriggerService } from './services/launched-hook-trigger.service';

@NgModule({
  imports: [CommonModule],
})
export class AppHookModule {
  constructor(injector: Injector) {
    InjectorClass.set(injector);
    injector.get<LaunchedHookTriggerService>(LaunchedHookTriggerService);
  }

  static forRoot(): ModuleWithProviders<AppHookModule> {
    return {
      ngModule: AppHookModule,
      providers: [],
    };
  }
}
